/**
 * Shared CSV import utilities for inventory (projects, configurations, units).
 */

export function escapeCSVCell(val) {
  const s = String(val ?? '');
  if (s.includes(',') || s.includes('"') || s.includes('\n') || s.includes('\r')) {
    return `"${s.replace(/"/g, '""')}"`;
  }
  return s;
}

export function downloadCSVTemplate(headers, exampleRows = [], filename = 'import_template.csv') {
  const headerLine = headers.map(escapeCSVCell).join(',');
  const rowLines = (exampleRows.length ? exampleRows : [headers.map(() => '')]).map((row) =>
    row.map(escapeCSVCell).join(',')
  );
  const csv = [headerLine, ...rowLines].join('\r\n');
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  link.setAttribute('href', URL.createObjectURL(blob));
  link.setAttribute('download', filename);
  link.click();
  URL.revokeObjectURL(link.href);
}

export function parseCSV(text) {
  if (!text || typeof text !== 'string') return { headers: [], rows: [] };
  const normalized = text.replace(/\r\n/g, '\n').replace(/\r/g, '\n').replace(/^\ufeff/, '');
  const lines = normalized.split('\n').map((s) => s.trim()).filter(Boolean);
  if (lines.length === 0) return { headers: [], rows: [] };
  const parseLine = (line) => {
    const out = [];
    let cur = '';
    let inQuotes = false;
    for (let i = 0; i < line.length; i++) {
      const c = line[i];
      if (c === '"') inQuotes = !inQuotes;
      else if ((c === ',' || c === '\t') && !inQuotes) {
        out.push(cur.trim());
        cur = '';
      } else cur += c;
    }
    out.push(cur.trim());
    return out;
  };
  const headers = parseLine(lines[0]).map((h) => (h.charCodeAt(0) === 0xFEFF ? h.slice(1) : h));
  const rows = lines.slice(1).map((line) => parseLine(line)).filter((r) => r.some((c) => c !== ''));
  return { headers, rows };
}

export function rowsToObjects(headers, rows) {
  return rows.map((row) => {
    const obj = {};
    headers.forEach((h, i) => { obj[h] = row[i] ?? ''; });
    return obj;
  });
}

/** Get value from row by key or alternate keys (case-insensitive match on header) */
export function getRowValue(row, ...keys) {
  const r = row || {};
  const lower = (k) => String(k || '').toLowerCase().replace(/\s+/g, '_');
  for (const k of keys) {
    const v = r[k] ?? r[lower(k)] ?? '';
    if (v !== '' && v != null) return String(v).trim();
  }
  return '';
}

export const MAX_FILE_SIZE_MB = 5;
export const MAX_ROWS_PREVIEW = 50;
